var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Notification_Pink_Filed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification_Pink_Filed",
    "data-name": "Notification Pink Filed",
    clipPath: "url(#clip-Notification_Pink_Filed)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3705",
    "data-name": "Group 3705",
    transform: "translate(-182.666 -248.526)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 2.437,
    height: 0.962,
    rx: 0.481,
    transform: "translate(182.667 258.435)",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 2.437,
    height: 0.962,
    rx: 0.481,
    transform: "matrix(0.863, 0.505, -0.505, 0.863, 184.071, 253.404)",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 2.437,
    height: 0.962,
    rx: 0.481,
    transform: "translate(187.844 249.762) rotate(60.667)",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 2.437,
    height: 0.962,
    rx: 0.481,
    transform: "translate(192.922 248.542) rotate(91.001)",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 2.437,
    height: 0.962,
    rx: 0.481,
    transform: "translate(197.927 250.034) rotate(121.335)",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 2.437,
    height: 0.962,
    rx: 0.481,
    transform: "translate(201.502 253.87) rotate(151.668)",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 2.437,
    height: 0.962,
    rx: 0.481,
    transform: "translate(202.634 258.969) rotate(-177.998)",
    fill: "#c06c84"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5998",
    "data-name": "Path 5998",
    d: "M36.777.193h4.642a.837.837,0,0,0,.715-.357,1.024,1.024,0,0,0,.019-.846h0l-.468-.713a.745.745,0,0,1-.112-.357V-6.838A4.761,4.761,0,0,0,39.9-10.409a5.083,5.083,0,0,0-3.1-1.429H35.519A5.2,5.2,0,0,0,30.831-6.77v4.644a.563.563,0,0,1-.089.38L30.3-.989a.708.708,0,0,0,0,.826.725.725,0,0,0,.645.357h4.644Z",
    transform: "translate(-26.199 17.273)",
    fill: "#c06c84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingPatient);
export default __webpack_public_path__ + "static/media/waitingPatient.6b4d5fc5280f6f450c2d3b0ba8e9bc6b.svg";
export { ForwardRef as ReactComponent };